"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFeeCap = exports.calculateFeeAmount = exports.calculateGrossAmount = void 0;
const utils_1 = require("../utils");
/**
 * Calculates gross payment amount required to get donation value after fee deduction
 */
const calculateGrossAmount = ({ amount, relative, fixed }) => {
    const relativeRate = relative / utils_1.CENTS_AMOUNT;
    const remainingPercentage = 1 - relativeRate;
    const netAmount = amount + fixed;
    return Number(netAmount / remainingPercentage);
};
exports.calculateGrossAmount = calculateGrossAmount;
/**
 * Calculates the fee amount that will be deducted from a donation.
 *
 * Used when donor does not cover fees (fees are subtracted from donation)
 */
const calculateFeeAmount = ({ amount, relative, fixed }) => {
    const relativeRate = relative / utils_1.CENTS_AMOUNT;
    const relativeFeeAmount = amount * relativeRate;
    return Number(relativeFeeAmount + fixed);
};
exports.calculateFeeAmount = calculateFeeAmount;
/**
 * Takes fees, and a cap, returns the capped fees regardless of the currency.
 * Negative cap is considered as no cap (infinity).
 */
const assertFeeCap = (uncapped, _cappedTotalFeeAmount) => {
    const cappedTotalFeeAmount = _cappedTotalFeeAmount < 0 ? Number.POSITIVE_INFINITY : _cappedTotalFeeAmount;
    if (uncapped.totalFeeAmount <= cappedTotalFeeAmount) {
        return uncapped;
    }
    const ratioDeedFeeOverTotalFee = uncapped.applicationFeeAmount / uncapped.totalFeeAmount;
    const cappedApplicationFeeAmount = cappedTotalFeeAmount * ratioDeedFeeOverTotalFee;
    const capped = {
        totalFeeAmount: cappedTotalFeeAmount,
        applicationFeeAmount: cappedApplicationFeeAmount,
        providerFeeAmount: cappedTotalFeeAmount - cappedApplicationFeeAmount,
    };
    return {
        ...capped,
        feesHistoryItem: {
            id: 'fee-cap',
            value: capped,
            date: new Date(),
        },
    };
};
exports.assertFeeCap = assertFeeCap;
//# sourceMappingURL=feeUtils.js.map